import { api } from '../utils/variables';

// Get auth token from localStorage
const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('authToken')}`
});

/**
 * Website (in-app) Notifications API Service
 * Centralized API calls for the polling-based notification bell
 */
export const notificationsApi = {
  /**
   * Fetch a page of website notifications for the logged-in user
   * @returns {Promise<Object>} { total, unread_count, page, page_size, pages, results }
   */
  fetchWebsiteNotifications: async ({ page = 1, pageSize = 20, unreadOnly = false } = {}) => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        page_size: String(pageSize),
        ...(unreadOnly ? { unread_only: 'true' } : {}),
      });

      const response = await fetch(`${api}/notifications/website?${params}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching website notifications:', error);
      throw error;
    }
  },

  /**
   * Mark a single notification as read
   * @param {string} id - Notification id
   */
  markNotificationRead: async (id) => {
    try {
      const response = await fetch(`${api}/notifications/website/${id}/read`, {
        method: 'PATCH',
        headers: getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  },

  /**
   * Mark all notifications as read
   * @returns {Promise<Object>} { updated }
   */
  markAllNotificationsRead: async () => {
    try {
      const response = await fetch(`${api}/notifications/website/read-all`, {
        method: 'POST',
        headers: getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  }
};

export default notificationsApi;
